import React from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';

import './VideoJobsSection.scss';

const VideoJobsSection = ({
  children,
  count = 0,
  emptyText,
  loading = false,
  loadingText,
  message = '',
  onRefresh,
  onStatusChange,
  statusOptions = [],
  statusValue = '',
  title,
  total = 0,
}) => (
  <section className="video-jobs-section">
    <div className="video-jobs-section__header">
      <div className="video-jobs-section__summary">
        <h4>{title}</h4>
        <span>显示 {count} / 共 {total} 条</span>
      </div>
      <div className="video-jobs-section__controls">
        <Form.Select
          size="sm"
          aria-label={`筛选${title}状态`}
          value={statusValue}
          onChange={(event) => onStatusChange(event.target.value)}
        >
          <option value="">全部状态</option>
          {statusOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
        <Button
          type="button"
          variant="outline-secondary"
          size="sm"
          className="video-jobs-section__refresh"
          title={`刷新${title}`}
          aria-label={`刷新${title}`}
          disabled={loading}
          onClick={onRefresh}
        >
          {loading
            ? <Spinner animation="border" size="sm" />
            : <i className="bi bi-arrow-clockwise" />}
        </Button>
      </div>
    </div>

    {message ? (
      <div className="video-jobs-section__message" role="alert">
        {message}
      </div>
    ) : null}

    {loading ? (
      <div className="video-jobs-section__state" aria-live="polite">
        <Spinner animation="border" size="sm" />
        <span>{loadingText}</span>
      </div>
    ) : count > 0 ? (
      <div className="video-jobs-section__grid">{children}</div>
    ) : (
      <div className="video-jobs-section__state">{emptyText}</div>
    )}
  </section>
);

export default VideoJobsSection;
